import AuthService from "../services/auth.service";

//vuex actions for login, logout and refresh token
export default {

  //login action
  login({ commit }, user) {
    return AuthService.loginService(user).then(
      user => {
        commit('loginSuccess', user);
        return Promise.resolve(user);
      },
      error => {
        commit('loginFailure');
        return Promise.reject(error);
      }
    );


  },


//logout action
  logout({ commit }) {
    commit('logout');
  },

  //refresh token action
  refreshToken({ commit }, accessToken) {
    commit('refreshToken', accessToken);
  }



}